<template>
  <tr>
    <td data-label="Name">
      <strong>
        <router-link :to="{ path: company.uuid, append: true }">
          {{ company.name }}
        </router-link>
      </strong>
    </td>
    <td data-label="Address">
      {{ company.postalAddress }}
    </td>
    <td data-label="Phone">
      <a :href="'tel:' + phone">
        {{ company.phone }}
      </a>
    </td>
    <td class="button-3 text-center">
      <button class="my-2 btn btn-warning" @click="editCompany()">
        <i class="fa fa-edit" /> Edit
      </button>
      <button class="my-2 btn btn-danger" @click="deleteCompany()">
        <i class="fa fa-trash" /> Delete
      </button>
    </td>
  </tr>
</template>

<script>
  export default {
    name: 'CompanyRow',
    props: {
      object: {
        type: Object
      },
      index: {
        type: Number
      }
    },
    computed: {
      phone () {
        if (this.company.phone) {
          return this.company.phone.replace(/\D/g, '')
        } else {
          return ''
        }
      },
      company () {
        return {
          Properties: [],
          ...this.object
        }
      }
    },
    methods: {
      editCompany () {
        this.$emit('edit', { permalink: 'editCompany', uuid: this.company.uuid })
      },
      deleteCompany () {
        this.$emit('deleteObject', { permalink: 'deleteCompany', uuid: this.company.uuid })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/rows/CompanyRow.vue